// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1___1a4eb80c04482137829","cls2":"PaperImages-cls2___d83ff7046e32f5305b6 PaperImages-cls1___1a4eb80c04482137829"};